import { combineReducers } from 'redux';

const bannerInitialState = {
  list: null,
  loadStatus: 0,
};

const bannerWeappInitialState = {
  list: null,
  loadStatus: 0,
};

const imgGroupInitialState = {
  list: null,
  loadStatus: 0,
};

const killInitialState = {
  data: null,
  loadStatus: 0,
};

const groupInitialState = {
  list: null,
  topicVo: null,
  loadStatus: 0,
  didLoadAll: false,
  query: {
    size: 20,
  },
};

const limitProductInitialState = {
  list: null,
  loadStatus: 0,
};

const presaleInitialState = {
  list: null,
  loadStatus: 0,
};

const themeInitialState = {
  list: null,
  loadStatus: 0,
  loadedAll: false,
};

const categoryInitialState = {
  list: null,
  loadStatus: 0,
};

const productInitialState = {
  list: null,
  loadStatus: 0,
  query: {
    tab: '',
    keyword: '',
  },
};

function bannerReducer(state = bannerInitialState, action) {
  switch (action.type) {
    case 'LOAD_HOME_BANNER_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_HOME_BANNER_LIST_COMPLETION': {
      const { error, list } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: list,
      };
    }
    default:
      return state;
  }
}

function bannerWeappReducer(state = bannerWeappInitialState, action) {
  switch (action.type) {
    case 'LOAD_WEAPP_BANNER_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_WEAPP_BANNER_LIST_COMPLETION': {
      const { error, list } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list,
      };
    }

    default:
      return state;
  }
}

function imgGroupReducer(state = imgGroupInitialState, action) {
  switch (action.type) {
    case 'LOAD_IMGGROUP_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_IMGGROUP_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: list,
      };
    }

    default:
      return state;
  }
}

function killReducer(state = killInitialState, action) {
  switch (action.type) {
    case 'LOAD_KILL_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_KILL_LIST_COMPLETION': {
      const { data, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        data: {
          ...data,
          listData: (data.listData || []).map(product => product.code),
        },
      };
    }

    default:
      return state;
  }
}

function groupReducer(state = groupInitialState, action) {
  switch (action.type) {
    case 'LOAD_HOME_GROUP_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
        topicVo: null,
      };
    }

    case 'LOAD_HOME_GROUP_LIST_COMPLETION': {
      const { error, willReload } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0,
          list: willReload ? null : state.list,
        };
      }

      const list = action.list.map(product => product.code);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: willReload ? list : (state.list || []).concat(list),
        topicVo: { ...state.topicVo, ...action.topicVo },
      };
    }

    default:
      return state;
  }
}

function productReducer(state = productInitialState, action) {
  switch (action.type) {
    case 'LOAD_HOME_PRODUCT_LIST': {
      return {
        ...state,
        loadStatus: 1,
        query: {
          tab: action.id,
        },
        list: null,
      };
    }

    case 'LOAD_HOME_PRODUCT_LIST_COMPLETION': {
      const { error, list } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: list.map(product => product.code),
      };
    }

    default:
      return state;
  }
}

function categoryReducer(state = categoryInitialState, action) {
  switch (action.type) {
    case 'LOAD_HOME_CATEGORY_LIST': {
      return {
        ...state,
        loadStatus: 1,
        list: null,
      };
    }

    case 'LOAD_HOME_CATEGORY_LIST_COMPLETION': {
      const { error, list } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }
      list.unshift({ channelId: '', title: '推荐' });
      return {
        ...state,
        loadStatus: 2,
        list,
      };
    }

    default:
      return state;
  }
}

function limitProductReducer(state = limitProductInitialState, action) {
  switch (action.type) {
    case 'LOAD_LIMIT_PRODUCT_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_LIMIT_PRODUCT_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list,
      };
    }

    default:
      return state;
  }
}

function presaleReducer(state = presaleInitialState, action) {
  switch (action.type) {
    case 'LOAD_PRESALE_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_PRESALE_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const idList = list.map(presale => ({
        ...presale,
        products: (presale.products || []).map(product => product.code),
      }));

      return {
        ...state,
        loadStatus: 2,
        list: idList,
      };
    }

    default:
      return state;
  }
}

function themeReducer(state = themeInitialState, action) {
  switch (action.type) {
    case 'LOAD_HOME_THEME_LIST':
    case 'LOAD_WEAPP_HOME_THEME_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_HOME_THEME_LIST_COMPLETION':
    case 'LOAD_WEAPP_HOME_THEME_LIST_COMPLETION': {
      const { data, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const topIdList = (data.tops || []).map(theme => ({
        ...theme,
        products: (theme.products || []).map(product => product.code),
      }));
      const otherIdList = (data.others || []).map(theme => ({
        ...theme,
        products: (theme.products || []).map(product => product.code),
      }));

      return {
        ...state,
        loadStatus: 2,
        list: {
          topsTheme: topIdList,
          othersTheme: otherIdList,
        },
      };
    }

    default:
      return state;
  }
}

function themesReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_PRESALE_LIST_COMPLETION': {
      if (action.error) {
        return state;
      }

      return action.list.reduce(
        (nextState, theme) => {
          nextState[theme.id] = theme;

          return nextState;
        },
        { ...state }
      );
    }

    case 'LOAD_WEAPP_HOME_THEME_LIST_COMPLETION':
    case 'LOAD_HOME_THEME_LIST_COMPLETION': {
      const { error, data } = action;
      if (error) {
        return state;
      }

      const list = (data.tops || []).concat(data.others || []);

      return list.reduce(
        (nextState, theme) => {
          nextState[theme.id] = theme;

          return nextState;
        },
        { ...state }
      );
    }

    default:
      return state;
  }
}

function mallLoadStatusReducer(state = 0, action) {
  switch (action.type) {
    case 'LOAD_HOME_MALL':
    case 'LOAD_WEAPP_HOME_MALL': {
      return 1;
    }

    case 'LOAD_HOME_MALL_COMPLETION':
    case 'LOAD_WEAPP_HOME_MALL_COMPLETION': {
      return action.error ? 0 : 2;
    }

    default:
      return state;
  }
}

function mallDidLoadAtReducer(state = 0, action) {
  switch (action.type) {
    case 'LOAD_HOME_MALL_COMPLETION':
    case 'LOAD_WEAPP_HOME_MALL_COMPLETION': {
      return action.error ? state : action.didLoadAt;
    }

    default:
      return state;
  }
}

export default combineReducers({
  loadInfo: combineReducers({
    loadStatus: mallLoadStatusReducer,
    didLoadAt: mallDidLoadAtReducer,
  }),
  banner: bannerReducer,
  bannerWeapp: bannerWeappReducer,
  imgGroup: imgGroupReducer,
  kill: killReducer,
  group: groupReducer,
  limitProduct: limitProductReducer,
  presale: presaleReducer,
  theme: themeReducer,
  themes: themesReducer,
  category: categoryReducer,
  product: productReducer,
});
